import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import {login} from 'flows/session/reducer';

import AuthService from '../utils/AuthService';

export class LoggedIn extends React.Component {
  componentDidMount() {
    /* eslint-disable no-new */
    // Have to do it this way because of how Auth0 works
    new AuthService((authResult) => {
      this.props.login(authResult);
    });
    /* eslint-enable no-new */
  }
  render() {
    return (
      <div>
        <img src="/images/ring.svg" alt="Loading" />
      </div>
    );
  }
}

LoggedIn.propTypes = {
  login: PropTypes.func.isRequired,
};

export default connect(null, {login})(LoggedIn);



// WEBPACK FOOTER //
// ./web/containers/LoggedIn.js